import { mat3 } from "gl-matrix";

/**
 * Creates an identity matrix as Float32Array for WebGL uniform functions
 */
export function createIdentityMatrix(): Float32Array {
    return mat3.create() as Float32Array;
}

/**
 * Creates multiple identity matrices for common WebGL operations
 */
export function createIdentityMatrices() {
    return {
        move: createIdentityMatrix(),
        rotate: createIdentityMatrix(),
        scale: createIdentityMatrix(),
        pan: createIdentityMatrix()
    };
}

/**
 * Resets WebGL transformation matrices to identity
 */
export function resetWebGLMatrices(context: WebGLRenderingContext, uniforms: {
    u_move: WebGLUniformLocation;
    u_rotate: WebGLUniformLocation;
    u_scale: WebGLUniformLocation;
    u_pan?: WebGLUniformLocation;
}) {
    context.uniformMatrix3fv(uniforms.u_move, false, createIdentityMatrix());
    context.uniformMatrix3fv(uniforms.u_rotate, false, createIdentityMatrix());
    context.uniformMatrix3fv(uniforms.u_scale, false, createIdentityMatrix());
    if (uniforms.u_pan) {
        context.uniformMatrix3fv(uniforms.u_pan, false, createIdentityMatrix());
    }
}
